import React from "react";
import { Box, CircularProgress, useMediaQuery } from "@mui/material";
import CaseDetail from "../components/CaseDetail";

const CaseDetailDialog = ({ open, onClose, loading }) => {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  if (!open) return null;
  return (
    <Box
      sx={{
        position: "absolute",
        width: { xs: "100%", xl: "calc(100% - 45px)" },
        height: "calc(100vh - 50px)",
        top: "50px",
        left: { xs: "0px", xl: "45px" },
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        boxSizing: "border-box",
      }}
      onClick={onClose}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          position: "relative",
          width: { xs: "100vw", xl: "calc(100vw - 45px)" },
          height: "calc(100vh - 50px)",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "row",
          overflowY: "clip",
        }}
      >
        {loading ? (
          <Box
            sx={{
              height: "10%",
              width: "100%",
              marginTop: "24px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={isMobileView ? 16 : 20} />
          </Box>
        ) : (
          <CaseDetail closeOnBack={onClose} />
        )}
      </Box>
    </Box>
  );
};

export default CaseDetailDialog;
